import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/index.css";
import { AuthProvider } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import AppLayout from "@/components/AppLayout";
import LoginPage from "@/pages/Login";
import Today from "@/pages/Today";
import Contacts from "@/pages/Contacts";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Finance from "@/pages/Finance";
import CalendarPage from "@/pages/Calendar";
import Tasks from "@/pages/Tasks";
import Documents from "@/pages/Documents";
import Campaigns from "@/pages/Campaigns";
import News from "@/pages/News";
import Analytics from "@/pages/Analytics";
import SettingsPage from "@/pages/Settings";
import DataPage from "@/pages/Data";
import GoogleCallback from "@/pages/GoogleCallback";
import Onboarding from "@/pages/Onboarding";
import Landing from "@/pages/Landing";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import JoinForm from "@/pages/JoinForm";
import HaloSplash from "@/components/HaloSplash";
import { Toaster } from "sonner";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <HaloSplash />
        <BrowserRouter>
          <Routes>
            <Route path="/welcome" element={<Landing />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/join/:token" element={<JoinForm />} />
            <Route path="/auth/google/callback" element={<GoogleCallback />} />
            <Route element={<AppLayout onboarding />}>
              <Route path="/onboarding" element={<Onboarding />} />
            </Route>
            <Route element={<AppLayout />}>
              <Route path="/" element={<Today />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:id" element={<ProjectDetail />} />
              <Route path="/finance/*" element={<Finance />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/tasks" element={<Tasks />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/campaigns" element={<Campaigns />} />
              <Route path="/news" element={<News />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/data" element={<DataPage />} />
              <Route path="/settings" element={<SettingsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
